import { render, staticRenderFns } from "./TrustYou.vue?vue&type=template&id=11bdbff0&scoped=true"
import script from "./TrustYou.vue?vue&type=script&lang=js"
export * from "./TrustYou.vue?vue&type=script&lang=js"
import style0 from "./TrustYou.vue?vue&type=style&index=0&id=11bdbff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bdbff0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TrustYouCategory: require('/vercel/path0/components/partials/TrustYouCategory.vue').default})
